import React, { useState, useEffect, useContext, useMemo, useRef } from 'react';

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import MultiSelect from '@shared/component/MultiSelect';
import { AuthContext } from '@shared/context/AuthContext';
import APIService from '../../shared/services/api';

function Filter(props: any) {
    const { setLoader }: any = useContext(AuthContext);
    const [locationData, setLocationData] = useState([]);
    const [showFilterDemand, setShowFilterDemand] = useState(false);
    const [state, setState] = useState(props?.checkData || {});
    const [demandTransporter, setDemandTransporter] = useState<any>(
        props?.checkData || {
            bidType: '',
            fromCity: '',
            toCity: '',
            status: '',
        },
    );

    const handelFilterModal = (flag: boolean) => {
        try {
            props?.handelFilterModal(flag);
        } catch (error) {}
    };

    // calling api

    const filterDemand = async (page: number = 1, clearAll) => {
        setLoader(true);
        try {
            let params;
            // console.log('-----', props.checkData, state, demandTransporter);
            // Construct query parameters based on demandTransporter state
            if (
                props?.checkData &&
                (Object.keys(props?.checkData).length == 0 || Object.keys(props?.checkData).length > 0)
            ) {
                params = {
                    order: 'desc',
                    sort: 'createdAt',
                };
                if (demandTransporter?.bidType || props?.checkData?.bidType) {
                    params['bidType'] = demandTransporter?.bidType || props?.checkData?.bidType || '';
                }

                if (demandTransporter?.status || props?.checkData?.status) {
                    params['status'] = demandTransporter?.status || props?.checkData?.status || '';
                }

                if (demandTransporter?.fromCity || props?.checkData?.fromCity) {
                    params['fromCity'] =
                        demandTransporter?.fromCity?.label ||
                        demandTransporter?.fromCity ||
                        props?.checkData?.fromCity?.label ||
                        props?.checkData?.fromCity ||
                        '';
                }

                if (demandTransporter?.toCity || props?.checkData?.toCity) {
                    params['toCity'] =
                        demandTransporter?.toCity?.label ||
                        demandTransporter?.toCity ||
                        props?.checkData?.toCity?.label ||
                        props?.checkData?.toCity ||
                        '';
                }
            } else {
                params = {
                    order: 'desc',
                    sort: 'createdAt',

                    // Spread the demandTransporter state
                };
            }

            if (clearAll) {
                params = {
                    page,
                    order: 'desc',
                    sort: 'createdAt',
                };
            }
            // console.log('params', params);

            // Filter out empty values from params
            const queryParams = Object.entries(params)
                .filter(([_, value]) => value !== '' && value !== null)
                .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                .join('&');

            const data = await APIService.getAll(`demand/search/filter?${queryParams}`, true, false);
            handelFilterModal(false);
            props.sendData(data, clearAll ? {} : state);
        } catch (err) {
            // Handle the error as needed
        } finally {
            setLoader(false);
        }
    };

    const getValue = (e: any) => {
        try {
            let data;
            const passData = { ...state, ...e };
            if (e.fromCity) {
                data = { ...demandTransporter, fromCity: e.fromCity?.label };
            } else if (e.toCity) {
                data = { ...demandTransporter, toCity: e.toCity?.label };
            } else {
                data = { ...demandTransporter, ...e };
            }

            setDemandTransporter(data);
            // console.log('passData', passData);

            setState(passData);
        } catch (error) {
            setLoader(false);
        }
    };

    const handleBidTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        let newBidType = '';

        // Toggle the bidType if the same checkbox is clicked
        if (demandTransporter.bidType !== value) {
            newBidType = value;
        }

        // Update the state using the getValue function
        getValue({ bidType: newBidType });
    };

    const handleStatusChange = event => {
        const { value } = event.target;
        let newStatus = '';

        // Toggle the status if the same checkbox is clicked
        if (demandTransporter.status !== value) {
            newStatus = value;
        }

        // Update the state using the getValue function
        getValue({ status: newStatus });
    };

    // Handle Clear ALL

    const handleClearAll = () => {
        try {
            if (props?.checkData && Object.keys(props?.checkData).length > 0) {
                filterDemand(1, true);
                return;
            }

            handelFilterModal(false);
        } catch (error) {}
    };

    return (
        <div>
            <Modal scrollable={true} show={true} backdrop="static" keyboard={false} size={'lg'}>
                <Modal.Header closeButton onClick={() => handelFilterModal(false)}>
                    <Modal.Title>Filters</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        <div className="material_form_cover">
                            <form
                                onSubmit={e => {
                                    e.preventDefault();
                                }}
                            >
                                <>
                                    <div className="field_box">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="field_box">
                                                    <h3>BID TYPE</h3>
                                                    <div className="check_field_box mb-4">
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="bidType"
                                                                id="autoBid"
                                                                value={'auto'}
                                                                onChange={e => handleBidTypeChange(e)}
                                                                checked={
                                                                    demandTransporter.bidType == 'auto' ||
                                                                    props?.checkData.bidType == 'auto'
                                                                }
                                                            />
                                                            <label className="form-check-label" htmlFor="autoBid">
                                                                Auto
                                                            </label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="bidType"
                                                                id="manualBid"
                                                                value={'manual'}
                                                                onChange={e => handleBidTypeChange(e)}
                                                                checked={
                                                                    demandTransporter.bidType == 'manual' ||
                                                                    props?.checkData.bidType == 'manual'
                                                                }
                                                            />
                                                            <label className="form-check-label" htmlFor="manualBid">
                                                                Manual
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="field_box">
                                                    <h3>STATUS</h3>
                                                    <div className="check_field_box mb-4">
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="status"
                                                                id="activeStatus"
                                                                value="active"
                                                                onChange={e => handleStatusChange(e)}
                                                                checked={
                                                                    demandTransporter.status == 'active' ||
                                                                    props?.checkData.status == 'active'
                                                                }
                                                            />
                                                            <label className="form-check-label" htmlFor="activeStatus">
                                                                Active
                                                            </label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="status"
                                                                id="inactiveStatus"
                                                                value="inactive"
                                                                onChange={e => handleStatusChange(e)}
                                                                checked={
                                                                    demandTransporter.status == 'inactive' ||
                                                                    props?.checkData.status == 'inactive'
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="inactiveStatus"
                                                            >
                                                                Inactive
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br></br>
                                </>

                                <div className="field_box">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <h3>PICK UP LOCATION</h3>
                                            <MultiSelect
                                                isSingle={true}
                                                options={props?.locationData}
                                                placeholder={'Select Pickup*'}
                                                getMultiSelectValue={(e: any) => {
                                                    getValue({ fromCity: e });
                                                }}
                                                isClearable={true}
                                                displayName="city"
                                                displayValue="id"
                                                setSelectedValues={props?.checkData?.fromCity || null}
                                            />
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-floating">
                                                <h3>DELIVERY LOCATION</h3>
                                                <MultiSelect
                                                    isSingle={true}
                                                    options={props?.locationData}
                                                    isClearable={true}
                                                    placeholder={'Select Drop*'}
                                                    getMultiSelectValue={(e: any) => {
                                                        getValue({ toCity: e });
                                                    }}
                                                    displayName="city"
                                                    displayValue="id"
                                                    setSelectedValues={props?.checkData?.toCity || null}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-sm-6"></div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <>
                        <Button
                            variant="default"
                            onClick={() => {
                                handleClearAll();
                            }}
                            className="btn custom_btn border_btn with_icon"
                        >
                            Clear All
                        </Button>
                        <Button variant="secondary" onClick={() => filterDemand()} className="btn dark_btn custom_btn">
                            Apply
                        </Button>
                    </>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default Filter;
